import { ToastContainer } from 'react-toastify';

export function Toaster() {
  return <ToastContainer position="top-center" />;
}
